// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"styles_tableHeader__1wsIb","parameters":"styles_parameters__2HL_q","comments":"styles_comments__13MdM"};